module.exports = __webpack_public_path__ + "static/media/103-marshall-island.bfe57244.svg";